import { css, styled } from '../../hooks/theme';
import { Size, Tokens } from '../../types';

interface DimensionProps {
  width?: string | number;
  size?: Size;
}

interface DropDownProps {
  show: boolean;
}

interface DropDownItemProps {
  active: boolean;
}

export const Container = styled.div<DimensionProps>`
  height: ${props => (props.size === 'sm' ? '36px' : '48px')};
`;

export const DropDownContainer = styled.div<DimensionProps & DropDownProps>`
  position: relative;
  z-index: 200;
  margin-top: 8px;
  padding: 8px 0;
  width: ${props => props.width || '100%'};
  max-height: 262px;

  background: ${props => props.theme.colors.neutral.grey[0]};
  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow-y: overlay;

  display: none;

  ${props =>
    props.show &&
    css`
      display: flex;
      animation: fadeIn 300ms ease-in-out forwards;
      transform-origin: top center;
    `}

  flex-direction: column;
`;
DropDownContainer.defaultProps = {
  theme: Tokens.eixods,
};

export const DropDownItem = styled.button<DropDownItemProps>`
  text-align: left;
  color: ${props => props.theme.colors.neutral.grey[100]};
  padding: 10px 16px;

  border: none;
  background: ${props =>
    props.active ? props.theme.colors.neutral.grey[5] : props.theme.colors.neutral.grey[0]};
  cursor: pointer;

  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
DropDownItem.defaultProps = {
  theme: Tokens.eixods,
};

export const NoResultsContainer = styled.div<DimensionProps>`
  padding: 16px;

  color: ${props => props.theme.colors.neutral.grey[70]};
`;
NoResultsContainer.defaultProps = {
  theme: Tokens.eixods,
};

export const IconContainer = styled.div`
  padding: 0;
  margin: 0;
  height: 24px;
  cursor: pointer;
  svg {
    pointer-events: none;
  }
`;
